<template>
  <div class="user_registration_div d-flex align-center ga-3">
    <!-- Buttons shown on desktop only -->
    <Button
    v-if="!isMobile"
    
    class="user_registration_button"
    label="log in"
    version="primary"
    :to="loginRoute"
    :slim="true"
    />
    <Button
    v-if="!isMobile"
    class="user_registration_button"
    label="Create Account"
    version="action"
    to="register"
    :slim="true"
    />
    
    <!-- Avatar link on Mobile Only -->
    <router-link to="/login" v-if="isMobile">
      <v-avatar :image="getResourceUrl(`/maya/icons/login-icon.png`)" size="40" />
      <v-tooltip activator="parent" location="bottom" class="hidden-xs">
        Login
      </v-tooltip>
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getResourceUrl, isMobile } from '@/services/admin_actions/apiUtils'

import Button from '@/components/ComponentLibrary/Button.vue'

const route = useRoute()
const loginRoute = computed(() => `/menu_login?action=logout&referer=${route.path}`)
</script>

<style lang="scss">

// Style the user registration bar
.user_registration_div {
  
  // Reduce the width of the buttons
  .user_registration_button{
    min-width: 175px !important;
  }
  
}

</style>
